<template>
  <div>
    <canvas ref="chart"></canvas>
  </div>
</template>

<script>
import { onMounted, ref, watch } from 'vue'
import Chart from 'chart.js/auto'

export default {
  props: {
    trainingCaloric: { type: Number, default: 0 },
    planAccumulated: { type: Number, default: 0 }
  },
  setup(props) {
    const chart = ref(null)
    let chartInstance = null

    const renderChart = () => {
      if (chartInstance) {
        chartInstance.destroy()
      }
      chartInstance = new Chart(chart.value, {
        type: 'bar',
        data: {
          labels: ['Gasto do mês', 'Acumulado'],
          datasets: [
            {
              label: 'Kcal',
              data: [
                props.trainingCaloric || 0,
                props.planAccumulated || 0
              ],
              backgroundColor: ['#ff9800', '#3f51b5']
            }
          ]
        },
        options: {
          responsive: true,
          plugins: {
            legend: { display: false }
          }
        }
      })
    }

    onMounted(renderChart)
    watch(() => [props.trainingCaloric, props.planAccumulated], renderChart)

    return { chart }
  }
}
</script>
